import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { BasicInformations } from '../models/basic-informations.model';

@Injectable({
    providedIn: 'root'
})
export class RoleSendService {
    private info: Subject<String> = new BehaviorSubject<String>('');

    get info$() {
        return this.info.asObservable();
    }

    addInfo(str: String) {
        this.info.next(str);
    }

}